import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import crypto from "crypto";
import Switch from "react-switch";
import { useSelector, useDispatch } from "react-redux";
import { FiLink, FiMenu, FiHelpCircle } from "react-icons/fi";
import { Typography, Box, Button, Tooltip } from "@material-ui/core";
import Popover from "@material-ui/core/Popover";
import IconButton from "@material-ui/core/IconButton";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import { Spinner } from 'reactstrap';

import Hidden from "@material-ui/core/Hidden";
import Gravatar from "react-gravatar";
import mixpanel from "mixpanel-browser";
import io from "socket.io-client";
import {
  addDays,
  isBefore,
  isWithinInterval,
  startOfDay,
  endOfDay,
} from "date-fns";

import { api } from "../../Services/Api";
import { db } from "../../Services/Firebase";
import logo from "../../logo.png";
import { setUserState } from "../../Store/Modules/User/Actions";
import { setHelpDialogState } from "../../Store/Modules/Dialogs/Actions";
import useSubscription from "../../Utils/useSubscription";

import Profile from "./Profile";
import Menu from "./Menu";
import HelpDialog from "./HelpDialog";
import { Brand, Container, MenuLink, Actions, OpenStoreSwitch } from "./style";

export default function Header() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [openMenu, setOpenMenu] = useState(false);

  const { isTrial, isSubscriber, isLoaded } = useSubscription();

  const socketIORef = React.useRef();
  const linkMenu = useSelector((state) => state.store.alias);
  const store = useSelector((state) => state.store);
  const storeActive = useSelector((state) => state.store.is_active);
  const [anchorEl, setAnchorEl] = React.useState(false);

  const handleSubscriptionPopover = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const handleSwitchChange = () => (checked, event) => {
    const closeStore = !checked;
    if (closeStore) return dispatch({ type: "CLOSE_STORE" });

    if (isTrial || isSubscriber) return dispatch({ type: "OPEN_STORE" });

    handleSubscriptionPopover(event);
  };

  function handleHelp() {
    mixpanel.track("Get Help");
    dispatch(setHelpDialogState("show", true));
    socketIORef.current.emit("events", "Evento enviado");
  }

  React.useEffect(() => {
    if (!socketIORef.current?.connected) {
      socketIORef.current = io.connect(process.env.REACT_APP_API_URL);
    }
  }, []);

  React.useEffect(() => {
    api.get("/portal/user").then(({ data }) => {
      dispatch(
        setUserState("userData", {
          ...data,
          createdAt: new Date(data.createdAt),
        })
      );
      mixpanel.identify(data._id);
      mixpanel.people.set_once({
        $email: data.email,
        "Sign up date": new Date(),
        USER_ID: data._id,
      });
      if (window.Conpass) {
        window.Conpass.init({
          name: data.name,
          email: data.email,

          // Informações opcionais (usado para segmentação)
          // custom_fields: {
          //   lang: "pt_BR",
          //   sexo: "Feminino",
          // }
        });
      }
    });
  }, [store]);

  // if (!isLoaded) return <div>Carregando...</div>;

  return (
    <>
      <Container>
        <div>
          <Hidden mdUp={true}>
            <Brand>
              <img src={logo} />
            </Brand>
          </Hidden>
          <Hidden mdUp={true}>
            <div style={{ fontSize: "10px" }}>{store.name}</div>
            <div>
              <IconButton onClick={handleHelp} color="secondary">
                <FiHelpCircle />
              </IconButton>
              <IconButton onClick={() => setOpenMenu(true)} color="primary">
                <FiMenu />
              </IconButton>
            </div>
          </Hidden>
          <Hidden smDown={true}>
            <div>{store.name}</div>
          </Hidden>

          <Actions>
            {!isLoaded ? (
              <div><Spinner type='grow' color='primary' /></div>
            ) : (
              <OpenStoreSwitch>
                <Switch
                  onChange={handleSwitchChange("is_active")}
                  checked={storeActive || false}
                  value={anchorEl}
                />
                <span>Abrir/Fechar</span>
              </OpenStoreSwitch>
            )}
            <MenuLink target="_blank" href={`https://${linkMenu}`}>
              <FiLink /> Ver Cardápio
            </MenuLink>
            <Tooltip title="Suporte">
              <IconButton
                style={{ padding: 0 }}
                onClick={() =>
                  window.open(
                    "https://api.whatsapp.com/send?phone=+553498807793"
                  )
                }
              >
                <WhatsAppIcon fontSize="large" />
              </IconButton>
            </Tooltip>
            <Profile />
          </Actions>
        </div>
      </Container>
      <Menu open={openMenu} onClose={() => setOpenMenu(false)} />
      <HelpDialog />
      <Popover
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Box style={{ padding: 10 }}>
          <Typography>
            A sua assinatura Expirou. <br />
            Clique no botão abaixo para renovar.
          </Typography>
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                history.push("/plans");
                handlePopoverClose();
              }}
            >
              Renovar
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
}
